import React from "react";
import { cn } from "../../lib/utils";
import { Link } from "react-router-dom";

function TextLink({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-darkgray underline underline-offset-4 decoration-border hover:decoration-darkgray"
    >
      {children}
    </a>
  );
}

const description = [
  <p key="now">
    I build products at <TextLink href="https://www.fanatics.live">Fanatics Live</TextLink> and{" "}
    <TextLink href="https://www.fanaticscollect.com">Fanatics Collect</TextLink>, where sports,
    collectibles, and consumer software meet. Before that I was a resident engineer at{" "}
    <TextLink href="https://veefriends.com">VeeFriends</TextLink>, working directly with{" "}
    <TextLink href="https://garyvaynerchuk.com">Gary Vaynerchuk</TextLink> and a lean internal tech team.
  </p>,
  <p key="side">
    I graduated from Penn State in
    Computer Science in May 2026. In high school I co-built School Timer, which reached about 33K
    users. Outside of work, I enjoy flying and catching sunsets.
  </p>,
];

const indexLinks = [
  { to: "/contact", label: "Get in touch" },
  { to: "/experience", label: "Experience" },
  { to: "/projects", label: "Projects" },
  { to: "/aviation", label: "Aviation" },
];

export function Hero({ className, ...props }) {

  return (
    <section
      className={cn(
        "mx-auto w-full max-w-[40rem] px-6 pt-28 pb-16 sm:pt-36 sm:pb-24",
        className
      )}
      {...props}
    >
      <h1 className="text-[2.5rem] sm:text-6xl font-medium tracking-[-0.04em] leading-[1.05] text-darkgray">
        I'm Krushil.
      </h1>

      <div className="mt-8 max-w-[36rem] space-y-5 text-[16px] sm:text-[17px] leading-[1.7] text-gray">
        {description}
      </div>

      <ul className="mt-14 border-t border-border">
        {indexLinks.map((link) => (
          <li key={link.to} className="border-b border-border">
            <Link
              to={link.to}
              className="group flex items-center justify-between py-4 text-[15px] text-darkgray focus-ring rounded-sm"
            >
              <span>{link.label}</span>
              <span className="text-lightgray transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-darkgray">
                →
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
